import { graphql } from '../../gql';

export const ENTITY_V3_QUERY = graphql(`
  query GetEntityDataV3($req: EntityV3Req) {
    entityV3(req: $req) {
      entity {
        name
        description
        founded
        headquarters
      }
      competitors {
        closeness
        id
        shortName
        longName
      }
    }
  }
`);
